<div class="modal active">
  <div class="modal__container">
      <div class="fields">
          <h2>Calculation Issues</h2>
          <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
              <div class="fields__container__tabs">
                <div class="fields__container__tabs__item">
                  <a href="#" data-tab="1" (click)="activateInvalid()" *ngIf="invalidNavaids != null && invalidNavaids.length > 0" [ngClass]="activeInvalid  ? 'active' : ''">NavAid Issues</a>
                  <a href="#" data-tab="1" (click)="activateIgnored()"  *ngIf="ignoredNavaids != null && ignoredNavaids.length > 0" [ngClass]="activeIgnored  ? 'active' : ''">NavAids Ignored</a>
                </div>
              </div>
              <div>
                <div class="fields__block">
                  <div class="fields__block__section">
                    <div *ngIf="activeInvalid && invalidNavaids.length > 0" class="table-fields">
                      <div>
                        <label>Please correct the NavAids bellow:</label>
                        <div class="table-container">
                          <table>
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Type </th>
                                <th>ICAO CC</th>
                                <th *ngIf="this.rangeLimitation == 'FOM'">FOM</th>
                                <th *ngIf="this.rangeLimitation == 'DOC'">DOC</th>
                                <th>Max Altitude</th>
                                <th *ngIf="this.rangeLimitation != 'FOM' && this.isPublishedElevation">Elevation [ft]</th>
                                <th *ngIf="this.rangeLimitation != 'FOM'">Terrain + Antenna [ft]</th>
                                <th>STATUS</th>
                            </thead>
                            <tbody>
                              <tr *ngFor="let navaid of invalidNavaids;let i = index" [class.highlighted]="navaid.isselected" (click)="selectNavaidRow(navaid)">
                                <td>
                                  <span>{{navaid.navaidid}}</span>
                                </td>
                                <td>
                                  <span>{{navaid.name}}</span>
                                </td>
                                <td>
                                  <span>{{navaid.navaidtype}}</span>
                                </td>
                                <td>
                                  <span>{{navaid.icaocc}}</span>
                                </td>
                                <td *ngIf="this.rangeLimitation == 'FOM'">
                                  <span>
                                    <select
                                    [(ngModel)]="navaid.arinc424fom"
                                    id="arinc424fom"
                                    name="arinc424fom"
                                    (ngModelChange)="updateFomValue(navaid)"
                                  >
                                    <option value="0: DOC < 25[NM] - ALTITUDE < 12000[FT]">0: DOC < 25[NM] - ALTITUDE < 12000[FT]</option>
                                    <option value="1: DOC < 40[NM] - ALTITUDE < 18000[FT]">1: DOC < 40[NM] - ALTITUDE < 18000[FT]</option>
                                    <option value="2: DOC < 130[NM] - ALTITUDE < 60000[FT]">2: DOC < 130[NM] - ALTITUDE < 60000[FT]</option>
                                    <option value="3: DOC > 130[NM]">3: DOC > 130[NM]</option>
                                    <option value="7: NOT INCLUDED">7: NOT INCLUDED</option>
                                    <option value="9: OUT OF SERVICE">9: OUT OF SERVICE</option>
                                  </select></span>
                                </td>
                                <td *ngIf="this.rangeLimitation == 'DOC'">
                                  <span><input [ngStyle]="{'background-color': utilsService.validDOC(navaid.doc)? '' : 'red' }" type="number" id="doc" name="doc" [(ngModel)]="navaid.doc" (ngModelChange)="updateDocValue(navaid)" ></span>
                                </td>
                                <td>
                                  <span>
                                    <input type="number" id="altitude" name="altitude" [ngStyle]="{'background-color': hasMaxAltitude[i]? '' : 'yellow' }"
                                    [(ngModel)]="navaid.maxaltitude" (ngModelChange)="updateAltitudeValue(navaid)">
                                  </span>
                                </td>
                                <td *ngIf="this.rangeLimitation != 'FOM' && this.isPublishedElevation">
                                  <span>
                                    <input type="number" id="navaidElevation" name="navaidElevation"
                                    [(ngModel)]="navaid.effectiveHeight" (ngModelChange)="updateNavaidElevationValue(navaid)">
                                  </span>
                                </td>
                                <td *ngIf="this.rangeLimitation != 'FOM'">
                                  <span>{{ terrainElevation[i]}}</span>
                                </td>
                                <td>
                                  <span *ngIf="isNavaidValid(navaid)" style="color: green;">VALID</span>
                                  <span *ngIf="!isNavaidValid(navaid)"  style="color: red;">INVALID</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                      </div>
                    </div>
                    <div *ngIf="activeIgnored && ignoredNavaids.length > 0" class="table-fields">
                      <div>
                        <div class="title">
                          <h4>List of incompatible navaids due to their type/antennaType/bias:</h4>
                        </div>
                        <div class="table-container">
                          <table>
                            <thead>
                              <th scope="col">ID</th>
                              <th scope="col">Name</th>
                              <th scope="col">Type</th>
                              <th scope="col">ICAO CC</th>
                              <th scope="col">User Defined</th>
                              <th scope="col">Latitude</th>
                              <th scope="col">Longitude</th>
                              <th scope="col">Antenna Type</th>
                              <th scope="col">Bias</th>
                            </thead>
                            <tbody>
                              <tr mdbTable *ngFor="let navaid of this.ignoredNavaids">
                                <td>{{navaid.id}}</td>
                                <td>{{navaid.name}}</td>
                                <td>{{navaid.navaidtype}}</td>
                                <td>{{navaid.icaocc}}</td>
                                <td>{{navaid.userdefined}}</td>
                                <td>{{navaid.latitude}}</td>
                                <td>{{navaid.longitude}}</td>
                                <td [ngStyle]="{'background-color':(navaid.navaidtype == 'DME_ILS' && navaid.antennatype != 'OMNIDIRECTIONAL' ) ? 'red': ''}">
                                  {{navaid.antennatype}}
                                  <!-- <span [ngStyle]="{'background-color' : navaid.navaitype == 'DME_ILS' && navaid.antennatype != 'OMNIDIRECTIONAL' ? 'red': ''}">{{navaid.antennatype}}</span>-->
                                </td>
                                <td [ngStyle]="{'background-color':(navaid.navaidtype == 'DME_ILS' && navaid.bias != 0 && navaid.bias != null) ? 'red':''}">
                                  {{navaid.bias}}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="fixMultiple" class="fields__btn">
                  <div *ngIf="this.rangeLimitation == 'DOC'">
                    <span >DOC:</span>
                    <input #doc_fix_multiple type="text" id="doc_fix_multiple" name="doc_fix_multiple">
                    <button type="submit" class="blue" (click)="fixDocAllNavaids(doc_fix_multiple.value)">Fix</button>
                  </div>
                  <div *ngIf="this.rangeLimitation == 'FOM'">
                    <span>FOM:</span>
                    <select #fom_fix_multiple id="arinc424fom" name="arinc424fom" [(ngModel)]="fomFixMultiple">
                      <option value="0: DOC < 25[NM] - ALTITUDE < 12000[FT]">0: DOC < 25[NM] - ALTITUDE < 12000[FT]</option>
                      <option value="1: DOC < 40[NM] - ALTITUDE < 18000[FT]">1: DOC < 40[NM] - ALTITUDE < 18000[FT]</option>
                      <option value="2: DOC < 130[NM] - ALTITUDE < 60000[FT]">2: DOC < 130[NM] - ALTITUDE < 60000[FT]</option>
                      <option value="3: DOC > 130[NM]">3: DOC > 130[NM]</option>
                      <option value="7: NOT INCLUDED">7: NOT INCLUDED</option>
                      <option value="9: OUT OF SERVICE">9: OUT OF SERVICE</option>
                    </select>
                    <button type="submit" class="blue" (click)="fixFomAllNavaids()">Fix</button>
                  </div>
                </div>
                <div [ngStyle]="{'display': activeInvalid? 'block' : 'none' }"class="fields__btn">
                  <button type="submit" class="blue" (click)="selectAllNavaids()">Select All</button>
                  <button type="submit" class="blue" (click)="deSelectAllNavaids()">DeSelect All</button>
                  <button *ngIf="this.isPublishedElevation" type="submit" class="blue" (click)="fixSelectedNavaidsElevation()">Fix Elevation</button>
                  <button type="submit" class="blue" (click)="fixMultiple=!fixMultiple">Fix Multiple</button>
                  <button type="submit" class="blue" (click)="performCalculation()">Ok</button>
                  <button *ngIf="performanceAnalysisDTO == null"type="submit" class="blue" (click)="performCalculationAndSave()">Save</button>
                  <button *ngIf="performanceAnalysisDTO != null "type="submit" class="blue" (click)="save()">Save</button>
                </div>
                <div [ngStyle]="{'display': activeIgnored? 'block' : 'none' }" class="fields__btn">
                  <button type="submit" class="blue" (click)="performCalculation()">Ok</button>
                </div>
              </div>


          </div>
      </div>
  </div>
</div>
